import React, { useEffect, useMemo } from "react"
import { StaticImage } from "gatsby-plugin-image"
import Stores from "./stores"
import useQueryParams from "query-params-hook"
import { replaceByDict } from "../utilities/replace-by-dict"

declare const window: any

export type DownloadPopupType = {
  onCloseClick: () => void | null
  isLpPage?: boolean
  show: boolean
}

const DownloadPopup = ({ show, isLpPage, onCloseClick }: DownloadPopupType) => {
  useEffect(() => {
    if (show) {
      typeof window !== `undefined` && typeof window.gtag === "function"
        ? window.gtag("event", "desktop_popup_open")
        : null
    }
  }, [show])
  const { campaignid, adgroupid, keyword, adid, lpurl, gclid} = useQueryParams()

  const replaceHashed = useMemo(
    () => ({ campaignid, adgroupid, keyword, adid, lpurl, gclid }),
    [campaignid, adgroupid, keyword, adid, lpurl, gclid]
  );

  const storesLinks = useMemo(() => {
    return isLpPage
      ? [
          {
            name: "Google",
            desktop: replaceByDict(
              "https://app.adjust.com/zuoayv2?campaign={campaignid}&adgroup={adgroupid}&creative={keyword}_{adid}&lpurl={lpurl}&external_click_id={gclid}",
              replaceHashed
            ),
          },
          {
            name: "Apple",
            desktop: replaceByDict(
              "https://app.adjust.com/imr1p88?campaign={campaignid}&adgroup={adgroupid}&creative={keyword}_{adid}&lpurl={lpurl}&external_click_id={gclid}&redirect=https://apps.apple.com/us/app/jackpot-party-casino-slots/id575980917?ppid=6a92d9c1-406f-464b-a0ee-02ccb01ac1ce",
              replaceHashed
            ),
          },
        ]
      : [
          { name: "Google", desktop: "https://app.adjust.com/11twtjhk" },
          { name: "Apple", desktop: "https://app.adjust.com/11tu4zkz" },
          { name: "Amazon", desktop: "https://app.adjust.com/11fdhhnp" },
          {
            name: "Facebook",
            desktop:
              "https://apps.facebook.com/jackpotpartycasino/?source=jackpotparty.com&campaign_id=popupbadges",
          },
        ];
  }, [isLpPage, replaceHashed]);

  return (
    <>
      <div
        onClick={onCloseClick}
        className={`popup-overlay${show ? " show-popup" : " hide-popup"}`}
      ></div>
      <div
        className={`download-popup py-7 px-4 sm:px-10 text-white md:flex md:justify-center${
          show ? " show-popup" : " hide-popup"
        }`}
        style={{top: `calc(${typeof window !== `undefined` ? window?.scrollY : 0}px + 12vh)`}}
      >
        <div className="flex flex-col space-y-5 items-center">
          <button className="close-popup text-5xl" onClick={onCloseClick}>
            X
          </button>
          <div className="flex flex-col items-center space-y-2">
            <StaticImage
              className="phone-image"
              width={240}
              src="../images/download-popup-phone.png"
              alt="Jackpot Party Mobile"
            />
            <div className="download-popup-title">DOWNLOAD & PLAY</div>

            {!isLpPage && 
              <div className="text-2xl py-5 text-center uppercase font-bold">
                scan qr code to play
                <div className="mt-5">
                  <StaticImage
                    src="../images/qr-code.png"
                    alt="qr code - scan to play"
                    width={170}
                  />
                </div>
              </div>
            }
          </div>
          <Stores
            links={storesLinks as any}
          />
        </div>
      </div>
    </>
  );
}

export default DownloadPopup
